import { Controller } from '@hotwired/stimulus';

// Paired chip pickers: a value held by one is not offered by the other, both ways. Reached
// through outlets because Stimulus connects an ancestor first, so on load the pickers do not
// exist yet when this controller does.
export default class extends Controller {
  static outlets = ['selected-chips-component'];

  // A picker's own select field connects after it, and `take` needs that controller.
  selectedChipsComponentOutletConnected() {
    cancelAnimationFrame(this.pendingSync);
    this.pendingSync = requestAnimationFrame(() => this.sync());
  }

  disconnect() {
    cancelAnimationFrame(this.pendingSync);
  }

  added({ target, detail: { value } }) {
    this.others(this.pickerFor(target)).forEach(other => other.take(value));
  }

  removed({ target, detail: { value, label } }) {
    this.others(this.pickerFor(target)).forEach(other => other.release(value, label));
  }

  // A draft saved before the pair was exclusive holds the value on both sides, which `take`
  // will not fix. The later picker drops it; the first keeps it.
  sync() {
    const pickers = this.selectedChipsComponentOutlets;

    pickers.forEach((picker, index) => {
      picker.values().forEach(value => {
        pickers.slice(index + 1).forEach(later => later.drop(value));
        pickers.filter(other => other !== picker).forEach(other => other.take(value));
      });
    });
  }

  others(picker) {
    return this.selectedChipsComponentOutlets.filter(other => other !== picker);
  }

  pickerFor(element) {
    return this.selectedChipsComponentOutlets.find(picker => picker.element === element);
  }
}
